import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";
import { PageHeader } from "@/components/common/page-header";
import {
  OSImageForm,
  OS_IMAGE_FORM_ID,
} from "@/components/admin/os-images/OSImageForm";
import { useCreateOSImage } from "@/hooks/useAdminOSImageQueries";
import type { OSImageFormData } from "@/schemas/adminOSImage.schema";

export function CreateOSImagePage() {
  const navigate = useNavigate();
  const createOSImage = useCreateOSImage();

  const handleSubmit = (data: OSImageFormData) => {
    createOSImage.mutate(data, {
      onSuccess: () => {
        // Back to the list: the image is created and there is no detail page to land on.
        navigate("/admin/os-images");
      },
    });
  };

  return (
    <div className="space-y-6">
      <PageHeader
        title="Create OS Image"
        subtitle="Add a new operating system image to the catalog"
        back={{
          label: "Back to OS Images",
          onClick: () => navigate("/admin/os-images"),
        }}
        action={
          <>
            <Button
              type="button"
              variant="outline"
              onClick={() => navigate("/admin/os-images")}
              disabled={createOSImage.isPending}
            >
              Cancel
            </Button>
            {/* Outside the <form>; `form` points at its id so this still submits it. */}
            <Button
              type="submit"
              form={OS_IMAGE_FORM_ID}
              disabled={createOSImage.isPending}
            >
              {createOSImage.isPending && (
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
              )}
              Create OS Image
            </Button>
          </>
        }
      />

      {/* The form renders its own section cards and preview; no wrapping card here. */}
      <OSImageForm onSubmit={handleSubmit} />
    </div>
  );
}
